class ChefCraftedMeals extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSlider();
  }

  initSlider() {

    const slider = this.querySelector('.swiper');

    if (!slider) return;

    new Swiper(slider, {

      slidesPerView: 1.2,
      spaceBetween: 20,

      scrollbar: {
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
      },

      breakpoints: {
        0: {
          slidesPerView: 1.2
        },
        540: {
          slidesPerView: 2.2
        },
        768: {
          slidesPerView: 3.2
        },
        1024: {
          slidesPerView: 4.2
        },
        1400: {
          slidesPerView: 5.2
        }
      }

    });

  }
}

customElements.define('chef-crafted-meals', ChefCraftedMeals);